export {version as default} from '../package.json';



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/version.js
// module id = 189
// module chunks = 0 1